export enum HealthData {
	BLOOD_GLUCOSE = 'blood_glucose',
	BLOOD_GLUCOSE_EXTRA = 'blood_glucose_extra',
	BLOOD_GLUCOSE_FASTING = 'blood_glucose_fasting',
	BLOOD_GLUCOSE_BEFORE_BREAKFAST = 'blood_glucose_before_breakfast',
	BLOOD_GLUCOSE_BEFORE_LUNCH = 'blood_glucose_before_lunch',
	BLOOD_GLUCOSE_BEFORE_DINNER = 'blood_glucose_before_dinner',
	BLOOD_GLUCOSE_AFTER_BREAKFAST = 'blood_glucose_after_breakfast',
	BLOOD_GLUCOSE_AFTER_LUNCH = 'blood_glucose_after_lunch',
	BLOOD_GLUCOSE_AFTER_DINNER = 'blood_glucose_after_dinner',
	BLOOD_GLUCOSE_BEFORE_SLEEP = 'blood_glucose_before_sleep',
	BLOOD_GLUCOSE_BEFORE_WORKOUT = 'blood_glucose_before_workout',
	BLOOD_GLUCOSE_3AM = 'blood_glucose_3am',
	BLOOD_PRESSURE_SYSTOLIC = 'blood_pressure_systolic',
	BLOOD_PRESSURE_DIASTOLIC = 'blood_pressure_diastolic',
	HEARTH_RATE = 'heart_rate',
	WEIGHT = 'weight',
	HEIGHT = 'height',
	WAISTLINE = 'waistline',
	STEP_COUNT = 'step_count',
	BREATHING_RATE = 'breathing_rate',
	OXYGEN_SATURATION = 'oxygen_saturation',
	SLEEP = 'sleep',
	HEMOGLOBIN = 'hemoglobin',
	HEMOGLOBIN_A1C = 'hemoglobinA1C',
	STRESS_LEVEL = 'stress_level',
	ACTIVE_ENERGY = 'active_energy_burned',
	DISTANCE_WALKING_RUNNING = 'distance_walking_running',
	WORKOUT = 'workout',
}
